<template>
    <div>
        <!-- 我的奖品 -->
		<van-dialog
			class="sign-dialog myprize"
			v-model="myprizeshow"
			width="350px"
			:show-confirm-button="false"
		>
			<div class="attractCode">
				<div class="top-title">我的奖品</div>
				<div class="title" style="height: 30px"></div>
				<div class="user-content " v-show="mywinnerLit.length">
					<div v-for="(item, index) in mywinnerLit" class="prizecontent" :key="index" v-if="item.lottery!=null">
						<div class="myprizeleft">
							<img :src="item.lottery.prizepic" alt="" />
							<div class="prizename">{{item.lottery.prizename}}</div>
							<div class="prizebutton" v-show="!item.user_address" @click="fnaddress(item.lottery.id)">填写地址</div>
						</div>
						<div class="myprizeright">
							<div class="prizeinfo">获奖时间：{{item.lottery.created_at}}</div>
							<div class="prizeinfo">快递地址：{{item.user_address || '' }}</div>
							<div class="prizeinfo">收件人员：{{item.user_name || '' }}</div>
							<div class="prizeinfo">手机号码：{{item.user_mobile || '' }}</div>
						</div>
					</div>
				</div>
				<div class="noprize" v-show="!mywinnerLit.length">暂无奖品</div>
                <div class="delButton" @click="fnclosemask"><van-icon name="cross" color="#bbb" /></div>
			</div>
		</van-dialog>

        <!-- 全部 中奖名单 -->
		<van-dialog
			class="sign-dialog lottery"
			v-model="winShow"
			width="350px"
			:show-confirm-button="false"
			:style="{ height: allLottery.length == 1 ? '300px' : 'auto' }"
		>
	
			<div class="attractCode">
				<div class="top-title">全部中奖名单</div>
				<div class="title" style="height: 30px"></div>
				<div class="user-content">
					<div class="gift-win" v-for="(item, index) in allLottery" :key="index">
						<div class="gift-tag">{{ item.level }}</div>
						<div class="good-name">{{ item.prizename }}</div>
						<van-grid :column-num="5" :border="false" class="attend-user">
							<van-grid-item class="attend-user-item"  v-for="(item1, index1) in item.winner_user" :key="index1">
								<div class="avatar">
									<img :src="item1.user.avatar" alt="" />
								</div>
								<div class="name">{{ item1.user.nick_name }}</div>
							</van-grid-item>
							<!-- <div style="text-align: center;width:100%;" v-show="!item.winner_user.length">暂无获奖人员</div> -->
						</van-grid>
					</div>
				</div>
                <div class="delButton" @click="fncloseallmask"><van-icon name="cross" color="#bbb" /></div>
			</div>
		</van-dialog>

        <!-- 活动奖品 -->
		<van-dialog class="sign-dialog gift" v-model="giftShow" width="320px" :show-confirm-button="false" >
			<div class="attractCode">
				<div class="top-title">活动奖品</div>
				<div class="title" style="height: 55px"></div>

				<van-grid :column-num="3" :border="false" class="gift-content">
					<van-grid-item class="gift-content-item" v-for="(item, index) in allLotteryList" :key="index">
						<div class="gift-content-item-in">
							<div class="gift-img">
								<img style="object-fit: contain" :src="item.prizepic" alt="" />
							</div>
							<!-- <span style="font-size: 12px; position: absolute; left: 50%; bottom: 10px; transform: translateX(-50%); font-weight: bold">{{
								item.prizename
							}}</span> -->
							<div class="tag">{{ item.level }}</div>
						</div>
					</van-grid-item>
				</van-grid>
				<div class="button" style="margin-top: 0">
					<div
						@click="fnmyprize"
						style="background-color: #ff657b; font-size: 12px; color: #fff; height: 30px; width: 70px; line-height: 30px; border-radius: 8px"
					>
						我的奖品
					</div>
					<div
						@click="openAll"
						style="background-color: #1ea0d9; font-size: 12px; color: #fff; height: 30px; width: 70px; line-height: 30px; border-radius: 8px"
					>
						中奖名单
					</div>
				</div>
                <div class="delButton" style="left: 93%;" @click="fnclosegift"><van-icon name="cross" color="#bbb" /></div>
			</div>
		</van-dialog>

        <!-- 抽奖进行中 -->
        <van-dialog
			class="sign-dialog lottery"
			v-model="lotteryShow"
			width="350px"
			:show-confirm-button="false"
		>
			<div class="attractCode">
				<div class="top-title">幸运抽奖</div>
				<div v-if="winSelf" class="title" style="">恭喜中奖</div>
				<div v-if="!winSelf" class="title" style="">遗憾，未中奖</div>

				<div class="good-img">
					<img :src="lotteryinfo.prizepic" />
				</div>
				<van-grid :column-num="5" class="attend-user" :border="false" style="border-bottom: none">
					<van-grid-item class="attend-user-item"  v-for="(item, index) in winUsersAni" :key="index">
						<div class="avatar">
							<img :src="item?.user?.avatar ? item.user.avatar : '../assets/images/head.jpg'" />	
						</div>
						<div class="name">{{ item?.user?.nick_name }}</div>
					</van-grid-item>
					
				</van-grid>
				<div >
					<div class="button-notice" style="font-size: ">
						<span>请获奖用户尽快提交收获地址</span>
						<span>超出7天未提交者视为自动放弃</span>
					</div>
					<div class="button" style="width: initial;justify-content: center">
						<div
							v-if="winSelf && !isMobile"
							@click="openAdress"
							style="background-color: #ff657b; font-size: 12px; color: #fff; height: 30px; width: 70px; line-height: 30px; border-radius: 8px;margin-right: 10px;"
						>
							填写地址
						</div>
						<div
							v-if="winSelf && isMobile"
							style="background-color: #ccc; font-size: 12px; color: #fff; height: 30px; width: 70px; line-height: 30px; border-radius: 8px;margin-right: 10px;"
						>
							已领取
						</div>
						<div
							@click="openAll"
							style="background-color: #1ea0d9; font-size: 12px; color: #fff; height: 30px; width: 70px; line-height: 30px; border-radius: 8px;margin-right: 10px;"
						>
							全部名单
						</div>
					</div>
				</div>
                <div class="delButton"  @click="lotteryClose"><van-icon name="cross" color="#bbb" /></div>
			</div>
		</van-dialog>


    </div>
</template>
<script>
import * as api from "@/api/live";

export default{
    props:{
        myprizeshow:{
            type:Boolean,
            default:false
        },
        giftShow:{
            type:Boolean,
            default:false
        },
        winShow:{
            type:Boolean,
            default:false
        },
        lotteryShow:{
            type:Boolean,
            default:false
        },
        winSelf:{
            type:Boolean,
            default:false
        },
        mywinnerLit:{
            type:Array,
            default:()=>[]
        },
        allLottery:{
            type:Array,
            default:()=>[]
        },
        winUsersAni:{
            type:Array,
            default:()=>[]
        },
        lotteryinfo:{
            type:Object,
            default:()=>{}
        },
        allLotteryList:{
            type:Array,
            default:()=>[]
        },
        isMobile:{
            type:String,
            default:''
        }
    },
    data(){
        return {
            
        }
    },
    methods: {
        fnaddress(id){
            this.$emit("fnaddress",id)
        },
        fnclosemask(){
            this.$emit("update:myprizeshow",false)
        },
        fncloseallmask(){
            this.$emit("update:winShow",false)
        },
        fnclosegift(){
            this.$emit("update:giftShow",false)
        },
        fnmyprize(){
            this.$emit("fnopenmyprize")
        },
        openAll(){
            this.$emit("openAlllottery")
        },
        openAdress(){
            this.$emit("fnopenAdress")
        },
        lotteryClose(){
            this.$emit("fnlotteryClose")
        }
       
        
    }
}
   
</script>

<style lang="less" scoped>
    @import "../assets/styles/dialogcommon.less";
    
</style>